import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";

// interface ConfigPanelData {
//   flowId: number;
// }
export interface ConfigPanelState {
  flowId: number;
}

const configPanelInitialState: ConfigPanelState | null = {
  flowId: 0,
};

const storedState: any = localStorage.getItem("configPanel");
const initialState =
  storedState && JSON.parse(storedState).length > 0
    ? JSON.parse(storedState)
    : {
        configPanel: configPanelInitialState,
      };

export const configPanelSlice = createSlice({
  name: "configPanel",
  initialState: initialState,
  reducers: {
    setFlowId: (state, action) => {
      state.configPanel.flowId = action.payload.flowId;
    },
  },
});

export const { setFlowId } = configPanelSlice.actions;

export const selectFlowId = (state: RootState) => state.configPanel.flowId;

export const configPanelReducer = configPanelSlice.reducer;
configPanelSlice.reducer = (state: any, action: any) => {
  const newState = configPanelReducer(state, action);
  localStorage.setItem("configPanelState", JSON.stringify(newState));
  return newState;
};

export default configPanelSlice.reducer;
